import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsalService } from '@azure/msal-angular';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-document-extension',
  templateUrl: './document-extension.component.html',
  styleUrls: ['./document-extension.component.scss']
})
export class DocumentExtensionComponent {

  @Output() answer = new EventEmitter<Boolean>();
  @Input() documentData: any = {};
  isProcessing = false;
  extesionsList: any = [];
  extensionData: any = {};
  isFileValid = false;
  searchValue: string = '';
  operationFlag: any;
  title = "";

  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;

  groupsSearchText: string = '';
  rejectReasonSearchText: string = '';
  reasonSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  columnList: any;
  visibleAddOrEditExtensionPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteExtensionPopup: MatDialogRef<TemplateRef<any>>;
  visibleExtensionDetailPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditExtensionPopup', { static: true }) addOrEditExtensionPopup: TemplateRef<any>;
  @ViewChild('deleteExtensionPopup', { static: true }) deleteExtensionPopup: TemplateRef<any>;
  @ViewChild('extensionDetailPopup', { static: true }) extensionDetailPopup: TemplateRef<any>;

  statusDropdown: any = [];
  reasonDropdown: any = [];
  rejectReasonDropdown: any = [];
  selectedReason: any = null;
  selectedRejectReason: any = null;
  selectedStatus: any;

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;

  visibleConfirmWithData: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithDataPopup', { static: true }) confirmWithDataPopup: TemplateRef<any>;

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: false
  };

  addOrEditExtensionPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteExtensionPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  confirmWithDataPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  extensionDetailPopupConfig = {
    width: '1200px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dateCustomClasses: DatepickerDateCustomClasses[];

  dateFormat: any = this.message.organizationDetails?.dateFormat == null ? 'DD-MMM-YYYY' : this.message.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  isAdenabled: boolean = false;

  constructor(public appService: AppService, private snackBar: MatSnackBar, public paginationService: PaginationService, public dialog: MatDialog, private authService: MsalService
    , public message: messageService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

  }

  refreshGrid() {
    this.parentFolderId = this.appService.getParentFolderId();
    this.isProcessing = true;
    this.appService.getDocumentExtensions(this.documentData['documentId'],
      this.documentData['version']).subscribe((data: any) => {
        this.isProcessing = false;
        this.extesionsList = data;
        this.collectionSize = this.extesionsList.length;
      })
  }
  uiDateFormat: any = 'dd-MMM-yyyy';
  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss'
  displayUserName: any;
  ngOnInit(): void {
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.message.isShowApplicableForAllCheckBox = false;
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');
    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM").replace("YYYY", "yyyy");

    }
    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y' ? true : false;
  }
  parentFolderId: any;
  moduleCode: any;
  item: any;
  submodule: any;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.documentData.module == "MYTASK") {
      this.columnList = [{ column: "Extension ID", width: "180px" }, { column: this.documentData.title + " Name", width: "200px" }, { column: this.documentData.subModule + " Name", width: "200px" },
      { column: "Owner", width: "200px" }, { column: "Requester", width: "280px" }, { column: "Requested On", width: "120px" },
      { column: "Pending With", width: "140px" }, { column: "Due On", width: "120px" }]
      this.parentFolderId = this.appService.getParentFolderId();
      let item1: boolean = true;
      this.item = this.documentData.item;
      let statusArray = this.documentData.item.split("(");
      for (let k = this.documentData.item.length - 1; k >= 0; k--) {
        if (this.documentData.item[k] == "(") {
          if (item1 == true) {
            this.status = this.documentData.item.slice(0, k);
            item1 = false;
          }


        }
      }
      this.moduleCode = this.documentData.moduleCode;
      this.submodule = this.documentData.subModule;

      this.isProcessing = true;
      const data2 = {

        module: this.moduleCode,
        status: this.status,
        subModule: this.submodule,
        isFrom: this.appService.getRouteOfMyTask()
      };
      this.appService.getSubTaskDetail(data2)
        .subscribe((data: any) => {
          if (data && Array.isArray(data)) {
            data.sort((a: any, b: any) => {
              const dateA = a.actionRequestedOn ? new Date(a.actionRequestedOn).getTime() : 0;
              const dateB = b.actionRequestedOn ? new Date(b.actionRequestedOn).getTime() : 0;
              return dateA - dateB;
            });
          }
          this.isProcessing = false;
          this.extesionsList = data;
          this.collectionSize = this.extesionsList.length;
        })
    } else {
      this.columnList = [{ column: "Extension Id", width: "120px" }, { column: "Expiry Date", width: "140px" }, { column: "To Be Extended Till", width: "140px" },
      { column: "Reason", width: "180px" }, { column: "CR", width: "200px" }, { column: "Status", width: "180px" },
      { column: "Created On", width: "180px" }, { column: "Created By", width: "140px" },
      { column: "Updated On", width: "180px" }, { column: "Updated By", width: "140px" }]
      this.parentFolderId = this.appService.getParentFolderId();
      this.isProcessing = true;
      this.appService.getDocumentExtensions(this.documentData['documentId'],
        this.documentData['version']).subscribe((data: any) => {
          this.isProcessing = false;
          this.extesionsList = data;
          this.collectionSize = this.extesionsList.length;
        })
    }

  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.extesionsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.extesionsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;
      for (let p = 0; p < this.extesionsList.length; p++) {
        this.extesionsList[p].childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (let p = 0; p < this.extesionsList.length; p++) {
        this.extesionsList[p].childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    //console.log(e);
    //console.log(list);
    //console.log(idx);
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  docFile: any
  docExtn: any;
  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.docFile = file;
      this.docExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substr(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file == undefined ? '' : file);
      formData.append("pageName", "DMS");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.isFileValid = true;

          } else {
            this.isFileValid = false;
            this.docFile = null;
            this.docExtn = '';
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        })
    } else {
      this.docFile = '';
      this.docExtn = '';
    }
  }

  addExtensionFunc(event: any) {
    this.extensionData['documentId'] = this.documentData['documentId'];
    this.extensionData['version'] = this.documentData['version'];
    this.extensionData['folderId'] = this.documentData['folderId'];
    if (this.documentData['expirationDate'] != null) {
      this.extensionData['currentExpiryDate'] = new Date(this.documentData['expirationDate']);
    }
    this.extensionData['toBeExtendedTill'] = null;
    this.extensionData['reason'] = null;
    this.extensionData['crNo'] = null;
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.title = "Add Extension";
    this.visibleAddOrEditExtensionPopup = this.dialog.open(this.addOrEditExtensionPopup, this.addOrEditExtensionPopupConfig);
  }

  editExtensionFunc(extension: any, event: any) {
    this.extensionData = extension;
    if (this.extensionData['currentExpiryDate'] != null) {
      this.extensionData['currentExpiryDate'] = new Date(this.extensionData['currentExpiryDate'])
    }
    if (this.extensionData['toBeExtendedTill'] != null) {
      this.extensionData['toBeExtendedTill'] = new Date(this.extensionData['toBeExtendedTill'])
    }
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = "Update Extesnion";
    this.visibleAddOrEditExtensionPopup = this.dialog.open(this.addOrEditExtensionPopup, this.addOrEditExtensionPopupConfig);
  }

  cancelAddAndEditFunction() {
    this.visibleAddOrEditExtensionPopup.close();
  }

  addOrUpdateExtension(question: any) {
    this.isProcessing = true;
    if (this.extensionData['currentExpiryDate'] !== null) {
      const expiryDateValue = new Date(this.extensionData['currentExpiryDate']);
      this.extensionData['currentExpiryDate'] = this.appService.dateZoneConvertion(expiryDateValue);
    }
    if (this.extensionData['toBeExtendedTill'] !== null) {
      const extendedDateValue = new Date(this.extensionData['toBeExtendedTill']);
      this.extensionData['toBeExtendedTill'] = this.appService.dateZoneConvertion(extendedDateValue);
    }
    if (this.extensionData['extensionId'] == null || this.extensionData['extensionId'] == undefined) {

      this.appService.addDocumentExtension(this.extensionData).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleAddOrEditExtensionPopup.close();
          this.isProcessing = true;
          this.appService.getDocumentExtensions(this.documentData['documentId'],
            this.documentData['version']).subscribe((data: any) => {
              this.isProcessing = false;
              this.extesionsList = data;
              this.collectionSize = this.extesionsList.length;
            })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    } else {
      delete this.extensionData['createdOn'];
      delete this.extensionData['updatedOn'];
      this.appService.updateDocumentExtension(this.extensionData).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleAddOrEditExtensionPopup.close();
          this.isProcessing = true;
          this.appService.getDocumentExtensions(this.documentData['documentId'],
            this.documentData['version']).subscribe((data: any) => {
              this.isProcessing = false;
              this.extesionsList = data;
              this.collectionSize = this.extesionsList.length;
            })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }


  }


  openDeletePopup(extension: any, event: any) {
    this.extensionData = extension;
    this.title = "Delete Extension";
    this.visibleDeleteExtensionPopup = this.dialog.open(this.deleteExtensionPopup, this.deleteExtensionPopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeleteExtensionPopup.close();
  }

  deleteFunction() {
    this.isProcessing = true;
 
    delete this.extensionData['createdOn'];
    delete this.extensionData['updatedOn'];
    this.appService.deleteDocumentExtension(this.extensionData).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.resultType == "S") {
      }
      this.visibleDeleteExtensionPopup.close();
      this.isProcessing = true;
      this.appService.getDocumentExtensions(this.documentData['documentId'],
        this.documentData['version']).subscribe((data: any) => {
          this.isProcessing = false;
          this.extesionsList = data;
          this.collectionSize = this.extesionsList.length;
        })
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: data.result,
          type: data.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: data.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    }, (error) => {
      this.displayMessage = error;
      this.displaySuccessMessage = false;
      this.displayErrorMessage = true;
      this.isProcessing = false;
      throw error;
    });

  }
  stageName: any;
  actionStatusOptions: any;
  buttonLabels: any = [];
  instructions: any;
  saveButtonForExtension = true;
  openDetailedpopup(extension: any, $event: any) {
    $event.preventDefault();
    if (this.documentData.module == "MYTASK") {

      this.isProcessing = true;
      this.appService.getDocumentExtensionByOnlyId(extension.subTaskNo)
        .subscribe((data: any) => {
          this.appService.getDocumentByDocumentId(extension['taskNo'],
            extension['version']).subscribe((data1: any) => {
              this.documentData = data1[0];
              this.documentData['module'] = "MYTASK";
              this.isProcessing = false;

              this.getInitCallForPopup(data[0]);
            })

        })
    } else {
      this.getInitCallForPopup(extension);
    }


    this.visibleExtensionDetailPopup = this.dialog.open(this.extensionDetailPopup, this.extensionDetailPopupConfig);

  }

  getInitCallForPopup(extension: any) {
    this.appService.getDocumentExtensionById(extension['documentId'], extension['version'], extension['extensionId'])
      .subscribe((data: any) => {
        this.extensionData = data[0];
        if (this.extensionData['currentExpiryDate'] != null) {
          this.extensionData['currentExpiryDate'] = new Date(this.extensionData['currentExpiryDate']);
        }
        if (this.extensionData['toBeExtendedTill'] != null) {
          this.extensionData['toBeExtendedTill'] = new Date(this.extensionData['toBeExtendedTill']);
        }
        this.extensionData['module'] = "DOCS_EXTENSION"
        this.extensionData['saveExtensionData'] = false;
        this.extensionData['folderId'] = this.documentData['folderId'];
        this.extensionData['isBlinded'] = 'N';
        this.title = "Extension - " + extension.extensionId;
        this.saveButtonForExtension = false;
        if (this.documentData.module == "MYTASK") {
          this.parentFolderId = this.documentData.folderId;
        }
        if (this.documentData['opern'] != "View") {
          this.isProcessing = true;
          let obj = {
            documentId: extension['documentId'],
            version: extension['version'],
            status: extension.status,
            folderId: this.parentFolderId,
            extensionOrWithdrawalId: extension.extensionId,
            pageName: 'EXTENSION'
          }
          this.appService.getDocumentButtonLabels(obj).subscribe((data: any) => {
            this.isProcessing = false;
            this.stageName = data.stageName;
            this.actionStatusOptions = data.actionStatusOptions;
            this.instructions = data.instructions;
            if (data.buttonLabels != null) {
              this.buttonLabels = data.buttonLabels.split(",");
              for (let i = 0; i < this.buttonLabels.length; i++) {
                if (this.buttonLabels[i] == "Save") {
                  this.saveButtonForExtension = true;
                  this.extensionData['saveExtensionData'] = true;
                  this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Save" });
                  i--;
                }
              }

            }
          })
        }

      })
  }

  cancelExtensionDetailFunction() {
    if (this.documentData.module == "MYTASK") {
      let item1: boolean = true;
      let statusArray = this.item.split("(");
      for (let k = this.item.length - 1; k >= 0; k--) {
        if (this.item[k] == "(") {
          if (item1 == true) {
            this.status = this.item.slice(0, k);
            item1 = false;
          }


        }
      }

      this.isProcessing = true;
      const data2 = {

        module: this.moduleCode,
        status: this.status,
        subModule: this.submodule,
        isFrom: this.appService.getRouteOfMyTask()
      };
      this.appService.getSubTaskDetail(data2)
        .subscribe((data: any) => {
          if (data && Array.isArray(data)) {
            data.sort((a: any, b: any) => {
              const dateA = a.actionRequestedOn ? new Date(a.actionRequestedOn).getTime() : 0;
              const dateB = b.actionRequestedOn ? new Date(b.actionRequestedOn).getTime() : 0;
              return dateA - dateB;
            });
          }
          this.isProcessing = false;
          this.extesionsList = data;
          this.collectionSize = this.extesionsList.length;
        })
    } else {
      this.isProcessing = true;
      this.appService.getDocumentExtensions(this.documentData['documentId'],
        this.documentData['version']).subscribe((data: any) => {
          this.isProcessing = false;
          this.extesionsList = data;
          this.collectionSize = this.extesionsList.length;
        })
    }
    this.visibleExtensionDetailPopup.close();
  }

  reason: any;
  buttonLabel: any;

  isEsignRequired = false;
  isReasonSignReqd = false;
  userName: any;
  password: any = "";
  actionStatus: any;
  comments: any;
  rejectReason: any;
  isConfirmationFileValid = false;
  statusList: any = [];
  rejectReasonList: any = [];
  reasonForSignatureList: any = [];
  moduleStages: any = [];
  dynamicButtonClick(button: string) {
    this.buttonLabel = button;
    if (button == "Delete" || button == "Activate" || button == "Update" || button == "Submit for Review" || button == "Submit for Approval"
      || button == "Self Assign" || button == "CheckOut" || button == "CheckIn" || button == "Submit for Signoff") {
      this.title = button;
      this.reason = null;
      if (button == "CheckOut" || button == "CheckIn") {
        this.reason = this.documentData.checkinoutComments;
      }
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else if (button == "Review" || button == "Approve" || button == "Signoff") {
      this.password = "";
      this.comments = "";
      this.statusDropdown = [];
      this.rejectReasonDropdown = [];
      this.userName = localStorage.getItem("loggedUserName");
      this.selectedReason = null;
      this.selectedStatus = [];
      this.selectedRejectReason = null;
      this.selectedReasonValue = "";
      this.selectedStatusValue = "";
      this.selectedRejectReasonValue = "";
      this.reasonDropdown = [];
      this.statusList = [];
      let data1 = [];
      if (this.actionStatusOptions != null) {
        data1 = this.actionStatusOptions.split(",");
      }
      for (let i = 0; i < data1.length; i++) {
        let data2 = data1[i].split("/");
        if (data2.length > 1) {
          this.statusList.push({ codelistCode: data2[1].trim(), codelistName: data2[0].trim() });
        } else {
          this.statusList.push({ codelistCode: data2[0].trim(), codelistName: data2[0].trim() });
        }

      }
      for (let i = 0; i < this.statusList.length; i++) {
        this.statusDropdown = this.statusDropdown.concat({
          valueExp: this.statusList[i].codelistCode,
          displayExp: this.statusList[i].codelistName
        });
      }
      this.isProcessing = true;
      this.appService.getCodeListsByGroup("DOCUMENT_REJECT_REASON").subscribe((data: any) => {
        this.rejectReasonList = data;
        this.isProcessing = false;
        for (let i = 0; i < this.rejectReasonList.length; i++) {
          this.rejectReasonDropdown = this.rejectReasonDropdown.concat({
            valueExp: this.rejectReasonList[i].codelistCode,
            displayExp: this.rejectReasonList[i].codelistName
          });
        }
      })
      this.isProcessing = true;
      this.appService.getModuleStages("DOCS", this.buttonLabel)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.moduleStages = data;
          if (data.length > 0) {
            if (data[0].esignReqd == "Y") {
              this.isEsignRequired = true;
            }
            if (data[0].reasonForSignatureReqd == "Y") {
              this.isReasonSignReqd = true;
            }
          }
        })
      this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
    } else {
      this.title = button;
      this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
    }

  }

  fileExtn: any;

  onConfirmFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.buttonOperationFile = file;
      this.fileExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substr(0, file.name.lastIndexOf('.'));
      const formData = new FormData();
      formData.append('file', file == undefined ? '' : file);
      formData.append("pageName", "DMS");
      formData.append("fileName", name);
      formData.append("extension", this.fileExtn);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.getInitCallForPopup(this.extensionData);
          } else {
            this.buttonOperationFile = null;
            this.fileExtn = '';
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        })
    } else {
      this.buttonOperationFile = '';
      this.fileExtn = '';
    }
  }

  reasonForSignature: any;
  statusChanges(status: any) {
    this.reasonDropdown = [];
    this.selectedReason = null;
    this.selectedReasonValue = "";
    this.isProcessing = true;
    let data = {
      stageName: "Extension " + this.buttonLabel,
      status: status,
      module: "DOCS",
    }
    if (this.documentData.belongsToIndividual == "Y") {
      this.appService.getReasonForSignsForBti(data).subscribe((data: any) => {
        this.isProcessing = false;
        this.reasonForSignatureList = data;
        for (let i = 0; i < this.reasonForSignatureList.length; i++) {
          this.reasonDropdown = this.reasonDropdown.concat({
            valueExp: this.reasonForSignatureList[i].reasonForSignature,
            displayExp: this.reasonForSignatureList[i].reasonForSignature
          });
        }
        if (this.reasonForSignatureList.length == 1) {
          this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

          this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
          for (let i = 0; i < this.reasonDropdown.length; i++) {
            if (this.reasonDropdown[i].valueExp == this.reasonForSignatureList[0].reasonForSignature) {
              this.selectedReason = this.reasonDropdown[i].valueExp;
              /*  this.selectedReason = [{
                 valueExp: this.reasonDropdown[i].valueExp,
                 displayExp: this.reasonDropdown[i].displayExp
               }] */
            }
          }
        }

      })
    } else {
      this.appService.getReasonForSigns(data).subscribe((data: any) => {
        this.isProcessing = false;
        this.reasonForSignatureList = data;
        for (let i = 0; i < this.reasonForSignatureList.length; i++) {
          this.reasonDropdown = this.reasonDropdown.concat({
            valueExp: this.reasonForSignatureList[i].reasonForSignature,
            displayExp: this.reasonForSignatureList[i].reasonForSignature
          });
        }
        if (this.reasonForSignatureList.length == 1) {
          this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

          this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
          for (let i = 0; i < this.reasonDropdown.length; i++) {
            if (this.reasonDropdown[i].valueExp == this.reasonForSignatureList[0].reasonForSignature) {
              this.selectedReason = this.reasonDropdown[i].valueExp;
              /*  this.selectedReason = [{
                 valueExp: this.reasonDropdown[i].valueExp,
                 displayExp: this.reasonDropdown[i].displayExp
               }] */
            }
          }
        }

      })
    }

  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  confirmWithReasonFunc() {
    this.isProcessing = true;
    if (this.reason == null && this.buttonLabel != 'Publish') {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else {
      let data = {

        documentId: this.documentData['documentId'],
        version: this.documentData['version'],
        currentStatus: this.extensionData['status'],
        stageName: null,
        buttonValue: this.buttonLabel,
        actionStatus: null,
        comments: this.reason,
        rejectReason: null,
        reasonForSignature: null,
        fileExtn: null,
        effectiveDate: this.documentData.effectiveDate,
        exprirationDate: this.documentData.expirationDate,
        pageName: "EXTENSION",
        extensionOrWithdrawalId: this.extensionData.extensionId
      }
      if (this.buttonLabel == "Submit for Review" || this.buttonLabel == "Submit for Approval" || this.buttonLabel == "Submit for Signoff") {
        data.stageName = this.stageName;
      }
      const formData = new FormData();
      const emptyfile: File | any = null;
      formData.append('file', emptyfile);
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('object', blob);
      this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleConfirmWithReason.close();

          this.getInitCallForPopup(this.extensionData);
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    }

  }


  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;
    const reasonValidationIcon = document.getElementById('reason-val-icon') as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;

    if (this.reason == "" || this.reason == null || this.reason == undefined) {
      reasonValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
      reasonValidationIcon.style.color = 'red';
      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      reasonValidationIcon.innerHTML = '';
      reasonValidationIcon.style.color = 'none';
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }
  }

  selectedRejectReasonValue: any = "";
  selectedStatusValue: any = "";
  selectedReasonValue: any = "";

  onStatusSelect(item: any) {
    this.selectedStatusValue = item;
    this.changetypeAddAndEditPassword = true;
    if (this.selectedStatusValue.includes("Requested More Info.")) {
      this.isReasonSignReqd = false;
    } else {
      this.isReasonSignReqd = this.moduleStages[0].reasonForSignatureReqd == "Y";
      this.statusChanges(this.selectedStatusValue);
    }

    if (this.rejectReasonList.length > 0 && (this.selectedStatusValue == 'Review Rejected'
      || this.selectedStatusValue == 'Approval Rejected')) {
      this.isShowRejectReason = true;
    } else {
      this.isShowRejectReason = false;
    }
  }
  onStatusRemoved(item: any) {
    this.selectedStatusValue = "";
    this.isShowRejectReason = false;
  }

  onReasonSelect(event: any, item: any) {
    if (event.isUserInput)
      this.selectedReasonValue = item?.valueExp ?? null;
  }

  onReasonSelectOld(item: any) {
    this.selectedReasonValue = item.valueExp;
  }
  onReasonRemoved(item: any) {
    this.selectedReasonValue = "";
  }
  onRejectReasonSelect(event: any, item: any) {
    if (event.isUserInput)
      this.selectedRejectReasonValue = item?.valueExp ?? null;
  }

  onRejectReasonSelectOld(item: any) {
    this.selectedRejectReasonValue = item.valueExp;
  }
  onRejectReasonRemoved(item: any) {
    this.selectedRejectReasonValue = "";
  }

  cancelConfirmFunc() {
    this.visibleConfirm.close();
  }

  buttonOperationFile: any | File;

  confirmOkFunc() {
    this.isProcessing = true;
    let data = {

      documentId: this.documentData['documentId'],
      version: this.documentData['version'],
      currentStatus: this.extensionData['status'],
      stageName: null,
      buttonValue: this.buttonLabel,
      actionStatus: null,
      comments: null,
      rejectReason: null,
      reasonForSignature: null,
      pageName: "EXTENSION",
      extensionOrWithdrawalId: this.extensionData.extensionId
    }
    const formData = new FormData();
    formData.append('file', this.buttonOperationFile);
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('object', blob);
    this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      this.visibleConfirm.close();
      if (Response.resultType == "S") {
        this.getInitCallForPopup(this.extensionData);

      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  cancelConfirmWithDataFunc() {
    this.visibleConfirmWithData.close();
  }


  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            console.log("inside");
            if (flag == "reviewAuthenable") {
              let data = {

                documentId: this.documentData['documentId'],
                version: this.documentData['version'],
                currentStatus: this.extensionData['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
                pageName: "EXTENSION",
                extensionOrWithdrawalId: this.extensionData.extensionId
              }
              const formData = new FormData();
              const emptyfile: File | any = null;
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.performButtonOperationForDocument(formData)
            }
            this.isProcessing = false;


          } else {
            console.log("outside");
            this.isProcessing = false;

          }

        },
        error: (error) => {
          this.isProcessing = false;
          console.log(error)

        }
      });



  }
  confirmWithDataFunc() {
    this.isProcessing = true;

    if (this.selectedRejectReason == null) {
      this.selectedRejectReasonValue = "";
    }
    if (this.selectedReason == null) {
      this.selectedReasonValue = "";
    }

    const isStatusMissing = !this.selectedStatusValue || this.selectedStatusValue == "";

    const isRejectMissing = (this.rejectReasonList.length > 0 &&
      (this.selectedStatusValue == "Review Rejected" || this.selectedStatusValue == "Approval Rejected") &&
      (!this.selectedRejectReasonValue || this.selectedRejectReasonValue == ""));

    const isSignReasonMissing = (this.isReasonSignReqd &&
      (!this.selectedReasonValue || this.selectedReasonValue == ""));

    if (isStatusMissing || isRejectMissing || isSignReasonMissing) {
      this.buttonOperationFieldValidation();
      this.isProcessing = false;
      return;
    }

    if (this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("reviewAuthenable");

    } else if (!this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.isProcessing = true;
      if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
        this.selectedStatusValue == "Approval Rejected") && !this.selectedRejectReasonValue) || (this.isReasonSignReqd && !this.selectedReasonValue)) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {

          documentId: this.documentData['documentId'],
          version: this.documentData['version'],
          currentStatus: this.extensionData['status'],
          stageName: this.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: this.selectedRejectReasonValue,
          reasonForSignature: this.selectedReasonValue,
          fileExtn: this.fileExtn,
          pageName: "EXTENSION",
          extensionOrWithdrawalId: this.extensionData.extensionId
        }
        const formData = new FormData();
        const emptyfile: File | any = null;
        formData.append('file', this.buttonOperationFile);
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('object', blob);
        this.performButtonOperationForDocument(formData)
      }
    }
    else if (this.isEsignRequired) {
      if (this.password == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = true;
            if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
              this.selectedStatusValue == "Approval Rejected") && !this.selectedRejectReasonValue) || (this.isReasonSignReqd && !this.selectedReasonValue)) {
              this.buttonOperationFieldValidation();
              this.isProcessing = false;
            } else {
              let data = {

                documentId: this.documentData['documentId'],
                version: this.documentData['version'],
                currentStatus: this.extensionData['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
                pageName: "EXTENSION",
                extensionOrWithdrawalId: this.extensionData.extensionId
              }
              const formData = new FormData();
              const emptyfile: File | any = null;
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.performButtonOperationForDocument(formData);
            }
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else {
      this.isProcessing = true;
      if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedReasonValue == "Review Rejected" ||
        this.selectedStatusValue == "Approval Rejected") && !this.selectedRejectReasonValue)) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          documentId: this.documentData['documentId'],
          version: this.documentData['version'],
          currentStatus: this.extensionData['status'],
          stageName: this.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: this.selectedRejectReasonValue,
          reasonForSignature: this.selectedReasonValue,
          fileExtn: this.fileExtn,
          pageName: "EXTENSION",
          extensionOrWithdrawalId: this.extensionData.extensionId
        }
        const formData = new FormData();
        const emptyfile: File | any = null;
        formData.append('file', this.buttonOperationFile);
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('object', blob);
        this.performButtonOperationForDocument(formData);
      }
    }
  }
  performButtonOperationForDocument(formData: FormData) {
    this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleConfirmWithData.close();
        this.getInitCallForPopup(this.extensionData);
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  isShowRejectReason = false;

  status: any;
  pass: any;
  rejectReason1: any;
  reasonForSignature1: any;

  statusRequiredMsg: any;
  passRequiredMsg: any;
  rejectReasonRequiredMsg: any;
  reasonForSignatureRequiredMsg: any;
  buttonOperationFieldValidation() {
    //this.isProcessing = true;
    this.status = document.getElementById('status') as HTMLInputElement;
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.rejectReason1 = document.getElementById('rejectReason') as HTMLInputElement;
    this.reasonForSignature1 = document.getElementById('reasonForSignature') as HTMLInputElement;

    this.statusRequiredMsg = document.getElementById('status-required-msg') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;
    this.rejectReasonRequiredMsg = document.getElementById('rejectReason-required-msg') as HTMLInputElement;
    this.reasonForSignatureRequiredMsg = document.getElementById('reasonForSignature-required-msg') as HTMLInputElement;


    if (this.selectedStatusValue == "") {
      this.status.style.border = '1px solid red';
      this.statusRequiredMsg.style.display = 'block';
    } else {
      this.status.style.border = 'none';
      this.statusRequiredMsg.style.display = 'none';
    }
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        this.pass.style.border = '1px solid red';
        this.passRequiredMsg.style.display = 'block';
      } else {
        this.pass.style.border = 'none';
        this.passRequiredMsg.style.display = 'none';
      }
    }
    if (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
      this.selectedStatusValue == "Approval Rejected")) {
      if (this.selectedRejectReasonValue == "") {
        this.rejectReason1.style.border = '1px solid red';
        this.rejectReasonRequiredMsg.style.display = 'block';
      } else {
        this.rejectReason1.style.border = 'none';
        this.rejectReasonRequiredMsg.style.display = 'none';
      }
    }

    if (this.isReasonSignReqd) {
      if (this.selectedReasonValue == "" || this.selectedReasonValue == null) {
        this.reasonForSignature1.style.border = '1px solid red';
        this.reasonForSignatureRequiredMsg.style.display = 'block';
      } else {
        this.reasonForSignature1.style.border = 'none';
        this.reasonForSignatureRequiredMsg.style.display = 'none';
      }
    }


  }

  isExtensionGridCollapsed = true;
  extensionExpandCollapseFunc() {
    if (this.isExtensionGridCollapsed) {
      this.isExtensionGridCollapsed = false;
    } else {
      this.isExtensionGridCollapsed = true;
    }
  }

  @ViewChild('searchCr', { static: true }) searchCr: TemplateRef<any>;
  visibleSearchCrPopup: MatDialogRef<TemplateRef<any>>;

  searchCrConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  selectedCrGroup: any = null;
  qmsGroupsList: any = [];
  checkoutcrId: any = null;
  checkoutcrNo: any = null;
  crValue: any = null;
  searchCrFunction() {
    this.selectedCrGroup = null;
    this.selectedCrGroupValue = null;
    this.searchedCrList = [];
    this.qmsGroupsList = [];

    this.appService.getQmsGroups().subscribe((data: any) => {
      for (let i = 0; i < data.length; i++) {
        if (data[i].modules.includes('CR')) {
          this.qmsGroupsList.push(data[i]);
        }
      }

      this.selectedCrGroup = null;
      this.selectBoxeForGroupValue();

    })
    this.isShowSearchedCrGrid = false;
    this.visibleSearchCrPopup = this.dialog.open(this.searchCr, this.searchCrConfig);
  }
  groupValueDropdown: any = [];
  selectedCrGroupValue: any = null;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (let i = 0; i < this.qmsGroupsList.length; i++) {
      this.groupValueDropdown.push({
        valueExp: this.qmsGroupsList[i].groupId,
        displayExp: this.qmsGroupsList[i].groupName
      });
    }
  }

  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedCrGroupValue = item?.valueExp ?? null;
    }
  }

  onGroupValueSelectOld(item: any) {
    this.selectedCrGroupValue = item.valueExp;
  }

  onGroupValueRemoved(item: any) {

  }

  gridResetFunction() {
    this.searchedCrList = [];
    this.selectedCrGroup = null;
    this.selectedCrGroupValue = null;
  }

  isShowSearchedCrGrid = false;
  searchedCrList: any = [];
  seachCrForDocumentsFunc() {
    this.isShowSearchedCrGrid = true;
    this.isProcessing = true;
    this.appService.getCrForDocuments(this.selectedCrGroupValue)
      .subscribe((data: any) => {
        this.searchedCrList = data;
        this.isProcessing = false;
      })
  }

  getSelectedCrNo: any = null
  getSelectedCrId: any = null
  searchCrChildCheckBoxChecked(e: any, cr: any, index: any) {
    if (e.target.checked) {
      cr.searchCrChildCheckBoxs = true;
      this.getSelectedCrNo = cr.crNo;
      this.getSelectedCrId = cr.crId;
    } else {
      cr.searchCrChildCheckBoxs = false;
      this.getSelectedCrNo = null;
      this.getSelectedCrId = null;
    }
  }

  addCrFunction() {
    this.extensionData.crNo = this.getSelectedCrNo;
    this.extensionData.crDetails = this.getSelectedCrId;
    this.visibleSearchCrPopup.close();
  }

  cancelCrFunction() {
    this.visibleSearchCrPopup.close();
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }
}
